import { cx } from "@/shared/lib/cx";

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  "aria-label"?: string;
}

export function Toggle({ checked, onChange, disabled, className, ...aria }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={cx("as-toggle", checked && "on", className)}
      onClick={() => onChange(!checked)}
      {...aria}
    >
      <span />
    </button>
  );
}
